import React, {Component} from "react"
import PropTypes from "prop-types"
import {FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"

export default class UserViewButton extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onButtonClick: PropTypes.func.isRequired
  }

  render() {
    const {onButtonClick} = this.props
    return (
      <Button id="adminSection_viewUser_button" small onClick={() => onButtonClick(this.props.user)}>
        <FormattedMessage id="admin.components.userViewButton.button.edit" />
      </Button>
    )
  }
}
